/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowsUp = createReactComponent("outline", "arrows-up", "IconArrowsUp", [["path", { "d": "M17 3l0 18", "key": "svg-0" }], ["path", { "d": "M4 6l3 -3l3 3", "key": "svg-1" }], ["path", { "d": "M20 6l-3 -3l-3 3", "key": "svg-2" }], ["path", { "d": "M7 3l0 18", "key": "svg-3" }]]);

export { IconArrowsUp as default };
//# sourceMappingURL=IconArrowsUp.mjs.map
